import React, { useState, useEffect } from 'react';
import { Box, Button, Divider, Typography, IconButton } from '@mui/material';
import MeetingCard from './cards/MeetingCard';
import CallBookingModal from '../CallBookingModal';
import MySkeleton from '../../../../components/Skeleton';
// import { PlusCircleIcon } from '../../../../utils/Icons';
import { getUserDetails } from '../../../../utils/orgName';
import { useUserRole } from '../../../../utils/useUserRole';
import { CardStyle } from '../../style-components/CardStyling';
import useUpcominMeeting from '../../../../queries/useUpcominMeeting';
import useResponsiveScreenSwitch from '../../../../utils/useResponsiveScreenSwitch';

const YourNextMeeting: React.FC<YourNextMeetingProps> = ({ loading, newScheduledMeeting, update }) => {
  const classess = CardStyle();
  const { isMentor } = useUserRole();
  const { forMobile } = useResponsiveScreenSwitch();
  const [isCalendarOpen, setCalendarOpen] = useState(false);
  const { orgId, location } = getUserDetails();

  const { data, refetch, isLoading } = useUpcominMeeting(orgId);

  const [meeting, setMeeting] = useState<any>(data ? data.data.data : null);
  // const handleCalendar = () => setCalendarOpen(true);

  /** Card title as per user */
  const cardTitle = isMentor ? 'My Next Meeting' : 'My Next Meeting';

  const fetchMeeting = async () => {
    refetch();
  };

  useEffect(() => {
    setMeeting(data?.data.data);
  }, [data]);

  const handleMeetingUpdate = () => {
    fetchMeeting();
  };

  useEffect(() => {
    fetchMeeting();
  }, [newScheduledMeeting, update]);

  const isDataLoading = loading || isLoading;
  const shouldShowButton = (isMentor && !meeting && !isDataLoading) || (!isMentor && !isDataLoading);
  console.log(isDataLoading, meeting, 'meeting data');

  return (
    <>
      <Box className={`${classess.cardBox} ${classess.flexColumn}`} minHeight={forMobile ? 'auto' : '240px'}>
        <Box px={2} gap={'16px'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
          <Typography variant={isMentor ? 'h6' : 'h5'} py={2}>
            {isDataLoading ? <MySkeleton width={150} /> : `${cardTitle}`}
          </Typography>
          {/* {shouldShowButton && (
            <IconButton size="small" onClick={handleCalendar}>
              <PlusCircleIcon size={30} />
            </IconButton>
          )} */}
        </Box>

        {!isMentor && <Divider />}

        {isDataLoading || meeting?._id ? (
          <Box p={2} pt={isMentor ? 0 : ''} display="flex" flexDirection="column" justifyContent="center" flex={1}>
            <MeetingCard
              key={meeting?._id}
              meeting={meeting}
              loading={isDataLoading}
              onMeetingCanceled={handleMeetingUpdate}
            />
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent={'center'} flex={1}>
            {/* <Button
              color="info"
              variant="contained"
              onClick={() => setCalendarOpen(true)}
              className="maxWidth-min-content"
            >
              Schedule Meeting
            </Button> */}
            <Typography p={2} textAlign={'center'}>
              Once you've scheduled a meeting.
            </Typography>
          </Box>
        )}
      </Box>

      {/* Call Booking Modal */}
      <CallBookingModal
        handleCloseModal={() => setCalendarOpen(false)}
        openFlag={isCalendarOpen}
        chatProfileName=""
        threadParticipantsUsers={[]}
        chatType="Chats"
        pageName="Calendar"
        bookedCallDetails=""
        onMeetingScheduled={fetchMeeting}
      />
    </>
  );
};

export default YourNextMeeting;
